import _ from 'lodash';
import UnderlyingPolicy from './UnderlyingPolicy';
import Vehicle from './PUPVehicle';
import Contact from './Contact';

let nextId;

const bindUnderlyingPolicyModel = (array = []) => {
    return _.map(array, (item) => {
        return new UnderlyingPolicy(item);
    }, this);
};

const bindVehicleModel = (array = []) => {
    return _.map(array, (item) => {
        return new Vehicle(item);
    }, this);
};

const bindContactModel = (array = []) => {
    return _.map(array, (item) => {
        return _.extend(item, {
            contact: new Contact(item.contact)
        });
    }, this);
};

const PUPSubmissionLobDataExtension = function (submission) {
    // eslint-disable-next-line prefer-destructuring
    nextId = submission.nextId;
    const data = submission.lobData.personalUmbrella;
    if (data && _.isObject(data)) {
        this.preQualQuestionSets = data.preQualQuestionSets;
        this.priorInsurance = data.priorInsurance;
        this.privacyDisclaimer = data.privacyDisclaimer;
        this.modifiers_ML = data.modifiers_ML;
        this.warnings = data.warnings;
        this.underlyingPolicies = bindUnderlyingPolicyModel(data.underlyingPolicies);
        this.umUimCov_ML = data.umUimCov_ML;
        this.coverables = {
            additionalInterests: data.coverables.additionalInterests,
            availableInsuredCandidates_Ext: data.coverables.availableInsuredCandidates_Ext,
            businessActivities: data.coverables.businessActivities,
            homeLosses_ML: data.coverables.homeLosses_ML || [],
            locations: data.coverables.locations,
            vehicleOperators: bindContactModel(data.coverables.vehicleOperators),
            vehicles: bindVehicleModel(data.coverables.vehicles),
            watercraftOperators: bindContactModel(data.coverables.watercraftOperators),
            watercrafts: data.coverables.watercrafts,
            addInterestTypeCategory: data.coverables.addInterestTypeCategory,
            disableRemoveBtnForPNIFlagInUMP_Ext: data.coverables.disableRemoveBtnForPNIFlagInUMP_Ext ?? false
        };
        this.offerings = data.offerings;
    } else {
        this.underlyingPolicies = [];
        this.coverables = {
            additionalInterests: [],
            availableInsuredCandidates_Ext: [],
            businessActivities: [],
            homeLosses_ML: [],
            locations: [],
            vehicleOperators: [],
            vehicles: [],
            watercraftOperators: [],
            watercrafts: []
        };
    }
};

PUPSubmissionLobDataExtension.prototype.beforeSave = function () {
    if (this.underlyingPolicies) {
        this.underlyingPolicies.forEach((ulPolicy) => {
            if (ulPolicy.ulPolicyFixID === 'new') {
                this.removeUnderlyingPolicy(ulPolicy);
            }
        });
    }
};

PUPSubmissionLobDataExtension.prototype.createUnderlyingPolicy = function (data) {
    const newUnderlyingPolicy = new UnderlyingPolicy(data);
    newUnderlyingPolicy.tempID = nextId();

    this.underlyingPolicies.push(newUnderlyingPolicy);

    return newUnderlyingPolicy;
};

PUPSubmissionLobDataExtension.prototype.removeUnderlyingPolicy = function (data) {
    const idx = _.indexOf(this.underlyingPolicies, data);
    if (idx >= 0) {
        this.underlyingPolicies.splice(idx, 1);
    }
};

export default PUPSubmissionLobDataExtension;
